function initSlider() {
  const slider = document.querySelector('.slider-wrapper');
  const slides = [...slider.children];
  const dotsContainer = document.querySelector('.slider-dots');
  let currentIndex = 0;
  let startX;
  let startY;
  let startTime;
  let isDown = false;
  let autoSlideTimer;
  let isUserInteracting = false;
  let isScrolling = false;
  let hasMoved = false;
  const swipeThreshold = 50;

  // Use Intersection Observer for lazy loading
  const imageObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const slide = entry.target;
        loadSlide(slide);
        imageObserver.unobserve(slide);
      }
    });
  }, {
    rootMargin: '50px 0px',
    threshold: 0.1
  });

  function loadSlide(slide) {
    if (slide.dataset.src) {
      const imgContainer = document.createElement('div');
      imgContainer.className = `main-offer-image-${slides.indexOf(slide) + 1}`;

      const img = document.createElement('img');
      img.src = slide.dataset.src;
      img.alt = slide.dataset.alt || `Slide ${slides.indexOf(slide) + 1}`;
      img.className = 'slider-image';
      img.width = slide.dataset.width || 500;
      img.height = slide.dataset.height || 500;
      img.loading = 'lazy';
      img.decoding = 'async';

      imgContainer.appendChild(img);
      slide.insertBefore(imgContainer, slide.firstChild);

      delete slide.dataset.src;
      delete slide.dataset.alt;
      delete slide.dataset.width;
      delete slide.dataset.height;
    }
  }

  function lazyLoadSlides() {
    slides.forEach((slide, index) => {
      if (index === 0) {
        loadSlide(slide); // Load first slide immediately
      } else {
        imageObserver.observe(slide); // Observe other slides
      }
    });
  }

  // Create dots using DocumentFragment for better performance
  const dotFragment = document.createDocumentFragment();
  slides.forEach((_, index) => {
    const dot = document.createElement('div');
    dot.className = `slider-dot${index === 0 ? ' active' : ''}`;
    dot.addEventListener('click', () => goToSlide(index));
    dotFragment.appendChild(dot);
  });
  dotsContainer.appendChild(dotFragment);
  const dots = [...dotsContainer.children];

  function goToSlide(index) {
    currentIndex = index;
    updateSlider();
  }

  function updateSlider() {
    requestAnimationFrame(() => {
      slider.style.transform = `translateX(-${currentIndex * 100}%)`;
      dots.forEach((dot, index) => {
        dot.classList.toggle('active', index === currentIndex);
      });
    });
  }

  function nextSlide() {
    if (!isUserInteracting) {
      currentIndex = (currentIndex + 1) % slides.length;
      updateSlider();
    }
  }

  function startAutoSlide() {
    autoSlideTimer = setTimeout(() => {
      nextSlide();
      startAutoSlide();
    }, 8000);
  }

  function stopAutoSlide() {
    clearTimeout(autoSlideTimer);
  }

  function resetAutoSlide() {
    stopAutoSlide();
    startAutoSlide();
  }

  // Use passive event listeners for better scroll performance
  function handleStart(e) {
    isDown = true;
    isUserInteracting = true;
    hasMoved = false;
    stopAutoSlide();
    startX = e.type === 'touchstart' ? e.touches[0].pageX : e.pageX;
    startY = e.type === 'touchstart' ? e.touches[0].pageY : e.pageY;
    startTime = new Date().getTime();
    isScrolling = false;
  }

  function handleEnd(e) {
    if (!isDown) return;
    isDown = false;
    isUserInteracting = false;
    resetAutoSlide();

    const endX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
    const deltaX = endX - startX;

    if (Math.abs(deltaX) > swipeThreshold) {
      currentIndex = deltaX > 0 ? Math.max(0, currentIndex - 1) : Math.min(slides.length - 1, currentIndex + 1);
      updateSlider();
    }
  }

  function handleMove(e) {
    if (!isDown) return;

    const x = e.type === 'touchmove' ? e.touches[0].pageX : e.pageX;
    const y = e.type === 'touchmove' ? e.touches[0].pageY : e.pageY;
    const walkX = x - startX;
    const walkY = y - startY;

    if (Math.abs(walkX) > 5 || Math.abs(walkY) > 5) {
      hasMoved = true;
    }

    if (!isScrolling && Math.abs(walkY) > Math.abs(walkX)) {
      isScrolling = true;
    }

    if (!isScrolling && Math.abs(walkX) > 5) {
      const percent = (walkX / slider.offsetWidth) * 100;
      const offset = -(currentIndex * 100) + percent;
      slider.style.transform = `translateX(${offset}%)`;
    }

    if (!isScrolling) {
      e.preventDefault();
    }
  }

  function handleClick(e) {
    if (!hasMoved) {
      const link = e.target.closest('.slider-link');
      if (link) {
        window.location.href = link.href;
      }
    } else {
      e.preventDefault();
      e.stopPropagation();
    }
  }

  // Add event listeners with passive option where appropriate
  slider.addEventListener('mousedown', handleStart);
  slider.addEventListener('touchstart', handleStart, { passive: true });
  slider.addEventListener('mouseup', handleEnd);
  slider.addEventListener('touchend', handleEnd);
  slider.addEventListener('mouseleave', handleEnd);
  slider.addEventListener('mousemove', handleMove);
  slider.addEventListener('touchmove', handleMove, { passive: false });
  slider.addEventListener('click', handleClick, true);

  // Initialize slider
  lazyLoadSlides();
  startAutoSlide();
}

// Use DOMContentLoaded for better performance
document.addEventListener('DOMContentLoaded', initSlider);